import { combineReducers } from "redux";
import refreshMuiReducer from "./refreshMuiReducer";
import loginReducer from "./loginReducer";
import yolreducer from "./Anasayfa/yol";
import seritreducer from "./Anasayfa/serit";
import armaturreducer from "./Anasayfa/armatur";
import tesisreducer from "./Anasayfa/tesis";
import markareducer from "./Anasayfa/marka";
import modelreducer from "./Anasayfa/model";


const rootReducer = combineReducers({
    refreshMui: refreshMuiReducer,
    login:loginReducer,
    yol:yolreducer,
    serit:seritreducer,
    armatur:armaturreducer,
    tesis:tesisreducer,
    marka:markareducer,
    model:modelreducer
});
export default rootReducer;
